<template>
  <div :style="{ width: width }">
    <el-popover
      placement="bottom-start"
      trigger="manual"
      :width="popWidth"
      v-model:visible="realPopShow"
    >
      <div class="content-wrap" data-id="course-cascader-content">
        <ul class="content" @scroll="onScroll">
          <li
            v-for="item in list"
            :key="item[realKeys.idKey]"
            @click="onItemClick(item)"
            class="flex-bewteen"
            :class="{ active: currentCourseId === item.id }"
          >
            <span>{{ displayFormat ? item[realKeys.showNameKey] : item[realKeys.nameKey] }}</span>
            <i class="el-icon-arrow-right"></i>
          </li>
          <div v-if="list.length === 0" class="empty" v-loading="loading">
            <div v-if="!loading">未查询到结果</div>
          </div>
          <div class="loading" v-if="list.length > 0 && !noPage && pageNum !== totalPage">
            加载中...
          </div>
        </ul>
        <ul class="content sup" v-if="currentCourseId">
          <li v-for="i in priceItemList" :key="i.id" @click="onPriceItemClick(i)">
            <span class="charge-type-tag" v-if="i.chargeType === 2">天</span>
            {{ i.priceItemName }}
          </li>
          <div
            v-if="priceItemList.length === 0 && currentCourseId"
            class="empty"
            v-loading="loading2"
          >
            <div v-if="!loading2">课程尚未定价</div>
          </div>
        </ul>
      </div>
      <template #reference>
        <el-input
          data-id="course-cascader-input"
          v-model="state"
          :placeholder="placeholder"
          :prefix-icon="prefixIcon"
          :disabled="disabled"
          clearable
          @clear="onClear"
          @focus="onFocus"
          @blur="onBlur"
          @input="onInput"
        ></el-input>
      </template>
    </el-popover>
  </div>
</template>

<script>
import {
  computed, defineComponent, inject, onMounted, onUnmounted, ref, watch,
} from 'vue';
import { debounce } from 'lodash';

export default defineComponent({
  props: {
    width: {
      type: String,
      default: '180px',
    },
    prefixIcon: String,
    placeholder: {
      type: String,
      default: '请选择',
    },
    keys: {
      type: Object,
      default: () => ({
        searchKey: 'curriculumName', // 接口查询字段
        idKey: 'id', // 接口id字段名称
        nameKey: 'curriculumName',
        showNameKey: 'showName',
      }),
    },
    queryParams: Object, // 额外的查询参数,有些接口需要
    displayFormat: Function,
    noPage: Boolean,
    disabled: Boolean,
    immediate: {
      type: Boolean,
      default: true,
    }, // 是否获取焦点立即查询
    isJustPriceItem: {
      type: Boolean,
      default: true,
    }, // 仅能选择课价
  },
  setup(props, { emit }) {
    const api = inject('api');
    const state = ref('');
    const stateTemp = ref('');
    const popShow = ref(false);
    const list = ref([]);
    const priceItemList = ref([]);
    const realKeys = computed(() => ({
      searchKey: 'queryKey', // 接口查询字段
      idKey: 'id', // 接口id字段名称
      nameKey: 'name',
      showNameKey: 'showName',
      ...props.keys,
    }));
    // const clickFlag = ref(false);
    const loading = ref(false);
    const loading2 = ref(false);
    const isStartQuery = ref(false);
    const pageNum = ref(1);
    const totalPage = ref(1);
    const currentCourseId = ref('');
    const currentCourse = ref({});

    const popWidth = computed(() => {
      const n = props.width.replace('px', '');
      const r = currentCourseId.value ? n * 2 : n * 1;
      return `${r}px`;
    });
    // const realPopShow = computed(() => popShow.value && list.value.length > 0);
    const realPopShow = computed(() => popShow.value && isStartQuery.value);

    const queryData = async () => {
      const params = {
        page: {
          pageNum: pageNum.value,
          pageSize: 10,
        },
      };
      if (realKeys.value.searchKey) {
        params[realKeys.value.searchKey] = state.value;
      }
      if (props.noPage) {
        delete params.page;
      }
      if (props.queryParams) {
        Object.assign(params, props.queryParams);
      }

      const { data, page } = await api.getCourseList(params).finally(() => {
        loading.value = false;
      });
      if (props.noPage) {
        list.value = data || [];
        if (props.displayFormat) {
          list.value = data?.map((it) => {
            const item = it;
            item[realKeys.value.showNameKey] = props.displayFormat(item);
            return item;
          }) || [];
        }
      } else {
        totalPage.value = page?.totalPage || 0;
        if (props.displayFormat) {
          const temp = data?.map((it) => {
            const item = it;
            item[realKeys.value.showNameKey] = props.displayFormat(item);
            return item;
          }) || [];
          list.value.push(...temp);
        } else {
          list.value.push(...(data || []));
        }
      }
    };
    const dd = debounce(() => {
      loading.value = true;
      isStartQuery.value = true;
      list.value = [];
      pageNum.value = 1;
      totalPage.value = 1;
      currentCourseId.value = '';
      queryData();
    }, 300);

    // 课价查询
    watch(currentCourseId, (val) => {
      loading2.value = true;
      api
        .getPriceitemList({ curriculumId: val })
        .then((res) => {
          if (res.code === 200) {
            priceItemList.value = res.data;
          }
        })
        .finally(() => {
          loading2.value = false;
        });
    });

    function bodyClick(ev) {
      if (ev.target?.dataset?.id === 'course-cascader-input') {
        return;
      }
      let flag = false;
      ev.path.forEach((item) => {
        if (item?.dataset?.id === 'course-cascader-content') {
          flag = true;
        }
      });
      if (flag) {
        return;
      }
      popShow.value = false;
      isStartQuery.value = false;
    }
    onMounted(() => {
      document.body.addEventListener('click', bodyClick, true);
    });
    onUnmounted(() => {
      document.body.removeEventListener('click', bodyClick);
    });
    return {
      realKeys,
      state,
      realPopShow,
      list,
      priceItemList,
      loading,
      loading2,
      pageNum,
      totalPage,
      currentCourseId,
      popWidth,
      onClear() {
        if (popShow.value) {
          dd();
        }
        emit('clear');
      },
      onFocus() {
        list.value = [];
        popShow.value = true;
        if (state.value.trim() || props.immediate) {
          stateTemp.value = state.value;
          state.value = '';
          // emit('clear');
          dd();
        }
      },
      onBlur() {
        state.value = stateTemp.value;
        // popShow.value = false;
        // isStartQuery.value = false;
        // if (props.notAutoTrigger) {
        //   return;
        // }
        // if (list.value.length > 0) {
        //   setTimeout(() => {
        //     if (clickFlag.value) {
        //       clickFlag.value = false;
        //       return;
        //     }
        //     const item = list.value[0];
        //     if (props.displayFormat) {
        //       state.value = item[realKeys.value.showNameKey].trim();
        //     } else {
        //       state.value = item[realKeys.value.nameKey].trim();
        //     }
        //     emit('select', {
        //       course: item,
        //     });
        //   }, 100);
        // } else {
        //   state.value = '';
        //   // emit('clear');
        // }
      },
      onInput() {
        if (realKeys.value.searchKey) {
          dd();
        }
      },
      onItemClick(item) {
        // clickFlag.value = true;
        currentCourse.value = item;
        currentCourseId.value = item[realKeys.value.idKey];
        if (props.isJustPriceItem) {
          return;
        }

        if (props.displayFormat) {
          state.value = item[realKeys.value.showNameKey].trim();
        } else {
          state.value = item[realKeys.value.nameKey].trim();
        }
        emit('select', {
          course: item,
        });
        // if (props.notAutoTrigger) {
        //   state.value = '';
        // }
      },
      onPriceItemClick(item) {
        popShow.value = false;
        isStartQuery.value = false;

        if (props.displayFormat) {
          state.value = `[${currentCourse.value[realKeys.value.showNameKey]}]${item.priceItemName}`;
        } else {
          state.value = `[${currentCourse.value[realKeys.value.nameKey]}]${item.priceItemName}`;
        }

        emit('select', {
          course: currentCourse.value,
          priceItem: item,
        });
      },
      clearField() {
        state.value = '';
      },
      setField(str) {
        state.value = str || '';
      },
      onScroll(ev) {
        if (props.noPage || totalPage.value === pageNum.value) {
          return;
        }
        const { clientHeight, scrollHeight, scrollTop } = ev.target;
        if (scrollTop >= scrollHeight - clientHeight - 10) {
          pageNum.value += 1;
          queryData();
        }
      },
    };
  },
});
</script>

<style lang="scss">
.empty {
  .el-loading-spinner {
    top: 0;
    margin-top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
  }
}
</style>
<style lang="scss" scoped>
.content-wrap {
  margin: -12px;
  display: flex;
}
.sup {
  border-left: 1px solid var(--g6);
}
.content {
  max-height: 300px;
  min-height: 100px;
  width: 250px;
  overflow: auto;
  .charge-type-tag {
      display: inline-block;
      margin-right: 4px;
      font-size: var(--fs-sm);
      line-height: var(--lh-sm);
      padding: 1px 4px;
      border-radius: 2px;
      white-space: nowrap;
      color: var(--warning);
      background: rgba(var(--warning-rgb), 0.15);
    }
  li {
    padding: 8px 10px;
    cursor: pointer;
  }
  li:hover,
  li.active {
    background-color: var(--g7);
  }

  .empty {
    height: 100px;
    color: var(--g4);
    line-height: 100px;
    text-align: center;
  }
  .loading {
    color: var(--g4);
    text-align: center;
    padding: 8px 10px;
  }
  .flex-bewteen {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
